import "@/App.css";
import "./styles/landing.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Privacy from "./pages/Privacy";
import DeleteAccount from "./pages/DeleteAccount";
import InviteGate from "./components/InviteGate";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/paymap">
        <Routes>
          <Route path="/" element={<InviteGate><Landing /></InviteGate>} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
